<template>
  <div>
    <div>
      <el-steps :active="active" :align-center="true">
        <el-step
          title="注册账号"
          :description="imported ? '已注册' : ''"
        ></el-step>
        <el-step title="导入话题" description="非必须"></el-step>
      </el-steps>
    </div>

    <div style="width: 50%;margin: 0 auto;">
      <div v-show="active == 0">
        <el-form ref="form" :model="registerRequest" label-width="120px">
          <!--                <div class="form-group{{ $errors->has('name') ? ' has-error' : '' }}">-->
          <b-alert show v-if="successMessage" variant="success">
            {{ successMessage }}
          </b-alert>
          <el-form-item
            label="用户名"
            autofocus
            prop="name"
            :rules="[{ required: true, message: '必填' }]"
          >
            <el-input
              v-model="registerRequest.name"
              :required="true"
            ></el-input>
            <b-alert show v-if="errors.name" variant="danger">
              <span v-for="(error, index) in errors.name" v-bind:key="index">
                {{ error }}
              </span>
            </b-alert>
          </el-form-item>
          <el-form-item
            label="邮箱地址"
            prop="email"
            :rules="[{ required: true, message: '必填' }]"
          >
            <el-input
              v-model="registerRequest.email"
              :required="true"
            ></el-input>
            <div>
              <el-form-item label="邮箱公开显示">
                <el-switch v-model="registerRequest.public_email"></el-switch>
              </el-form-item>
            </div>
            <div>
              <b-alert show v-if="errors.email" variant="danger">
                <span v-for="(error, index) in errors.email" v-bind:key="index">
                  {{ error }}
                </span>
              </b-alert>
              <b-alert show v-if="errors.public_email" variant="danger">
                <span
                  v-for="(error, index) in errors.public_email"
                  v-bind:key="index"
                >
                  {{ error }}
                </span>
              </b-alert>
            </div>
          </el-form-item>
          <el-form-item label="性 别" prop="gender">
            <el-select v-model="registerRequest.gender" placeholder="性 别">
              <el-option key="secret" label="保密" value="secret"></el-option>
              <el-option key="female" label="女" value="female"></el-option>
              <el-option key="male" label="男" value="male"></el-option>
            </el-select>
            <b-alert show v-if="errors.gender" variant="danger">
              <span v-for="(error, index) in errors.gender" v-bind:key="index">
                {{ error }}
              </span>
            </b-alert>
          </el-form-item>
          <el-form-item
            label="密 码"
            prop="password"
            :rules="[{ required: true, message: '必填' }]"
          >
            <el-input
              type="password"
              v-model="registerRequest.password"
              autocomplete="off"
            ></el-input>
            <b-alert show v-if="errors.password" variant="danger">
              <span
                v-for="(error, index) in errors.password"
                v-bind:key="index"
              >
                {{ error }}
              </span>
            </b-alert>
          </el-form-item>
          <el-form-item
            label="确认密码"
            prop="password_confirmation"
            :rules="[{ required: true, message: '必填' }]"
          >
            <el-input
              type="password"
              v-model="registerRequest.password_confirmation"
              autocomplete="off"
            ></el-input>
            <b-alert show v-if="errors.password_confirmation" variant="danger">
              <span
                v-for="(error, index) in errors.password_confirmation"
                v-bind:key="index"
              >
                {{ error }}
              </span>
            </b-alert>
          </el-form-item>
          <!--captcha-->
          <el-form-item>
            <el-button type="submit" @click="register">注册</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div v-show="active == 1">
        <div>
          <h6>导入HoustonBBS话题，请新前往邮箱激活账号，然后刷新页面</h6>
          <br />
          <br />
          <div v-if="imported && !isLoggedIn">
            <el-alert
              title="此用户已成功注册，登录后可以导入话题！"
              type="success"
            >
            </el-alert>
            <Login :redirect="'/import/' + userToken"></Login>
          </div>
          <div v-else v-bind:key="topic.nid" v-for="topic in importedTopics">
            <el-button
              size="small"
              @click="storeImportedTopic(topic.nid, topic.title)"
              >导入</el-button
            >
            &nbsp;<a
              :href="'https://www.houstonbbs.com/node/' + topic.nid"
              target="_blank"
            >
              {{ topic.title }}
            </a>
          </div>
          <!--<el-checkbox label="selected and disabled" disabled></el-checkbox><br/>-->
        </div>
        <b-modal
          ref="importTopic"
          centered
          scrollable
          title="导入话题"
          size="xl"
          hide-footer
        >
          <TopicImport
            :editTopic="importedTopic"
            @close="closeImportTopic"
          ></TopicImport>
        </b-modal>
      </div>
      <el-button v-if="registered" @click="next" class="float-right">{{
        active == 0 ? "下一步" : "上一步"
      }}</el-button>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";
import TopicPostComponent from "../components/TopicPostComponent.vue";
import Login from "./Login.vue";

export default {
  data() {
    return {
      importedTopics: [],
      importedTopic: "",
      active: 0,
      registered: false,
      imported: false,
      registerRequest: {
        name: "",
        email: "",
        gender: "secret",
        public_email: true,
        password: "",
        password_confirmation: ""
      },
      errors: {
        name: "",
        email: "",
        gender: "",
        public_email: "",
        password: "",
        password_confirmation: ""
      },
      successMessage: ""
    };
  },
  computed: {
    ...mapGetters(["isLoggedIn"]),
    ...mapState(["user", "token"])
  },
  components: {
    TopicImport: TopicPostComponent,
    Login
  },
  props: {
    userToken: {
      type: String,
      required: false
    }
  }, //user id
  watch: {
    imported: function(newValue) {
      this.active = newValue ? 1 : 0;
    }
  },
  methods: {
    ...mapMutations(["setLoading", "loginWithToken"]),
    closeImportTopic: function() {
      this.$bvModal.hide("importTopic");
    },
    storeImportedTopic: function(id, title) {
      this.setLoading(true);
      //post topic from houstonbbs
      this.$axios
        .post("/import/houstonbbs/store", {
          id: id
        })
        .then(response => {
          var images = [];
          this.importedTopic = {
            id: "",
            category_id: "",
            published: true,
            zipcode: "",
            image_url: "",
            tags: [],
            title: title,
            body: response.data.content,
            images: JSON.stringify(images)
          };
          this.$refs["importTopic"].show();
          this.setLoading(false);
        });
    },
    getImportedTopics: function() {
      //fetch all tags
      this.$axios.get("/import/houstonbbs/" + this.userToken).then(response => {
        switch (response.data.sex) {
          case 1:
            this.registerRequest.gender = "male";
            break;
          case 2:
            this.registerRequest.gender = "female";
            break;
          default:
            this.registerRequest.gender = "secret";
        }

        this.imported = response.data.imported == 1 ? true : false;
        this.registerRequest.name = response.data.username;

        this.importedTopics = response.data.topics;
      });
    },
    next: function() {
      this.active = ++this.active % 2;
    },
    register: function() {
      this.successMessage = "";
      this.errors = {
        name: "",
        email: "",
        gender: "",
        public_email: "",
        password: "",
        password_confirmation: ""
      };
      this.$axios({
        url:
          process.env.VUE_APP_API_BASE_URL +
          "/import/houstonbbs/register/" +
          this.userToken,
        data: this.registerRequest,
        method: "POST"
      })
        // this.$store
        //     .dispatch("register", this.registerRequest)
        .then(res => {
          if (res.status == 201) {
            this.successMessage = res.data.message;
            this.registered = true;
            this.$store
              .dispatch("login", {
                username: this.registerRequest.name,
                password: this.registerRequest.password
              })
              .then(res => {
                if (res.status === 201) {
                  this.successMessage =
                    "已成功注册并已登录，请先前往邮箱地址激活账号";
                }
              })
              .catch(err => {
                if (err.response.data.errors) {
                  this.errors = err.response.data.errors;
                } else {
                  this.message = err.response.data.message;
                }
              });
          }
        })
        .catch(err => {
          this.errors = err.response.data.errors;
        });
    }
  },
  // set the layout to user when it's mounted.
  mounted: function() {
    this.getImportedTopics();
  },
  updated() {
    if (this.isLoggedIn && this.imported) {
      this.active = 1;
    }
  }
};
</script>
